// Centralised date formatting for ChildCheckOh.
// User requirement (iter-81v, Feb 2026): display all dates as MM/DD/YYYY
// site-wide (previously MM/DD/YY was used to fit the narrow DCY 01234 signature
// field — that form is now generated separately and the display shortcut is
// no longer wanted). Input pickers stay as native <input type="date">, which
// continues to accept/return the ISO format "YYYY-MM-DD" — we only transform
// the *display*.

const pad2 = (n) => String(n).padStart(2, "0");
const pad4Year = (yyyy) => {
  const s = String(yyyy);
  if (s.length === 4) return s;
  if (s.length === 2) return (Number(s) >= 70 ? "19" : "20") + s;
  return s;
};

/**
 * Convert any date-ish input to MM/DD/YYYY for display.
 * Accepts:
 *   - "YYYY-MM-DD"
 *   - "YYYY-MM-DDTHH:MM:SS..." (ISO datetime — date portion only)
 *   - "MM/DD/YY" or "MM/DD/YYYY" or "MM-DD-YY" — normalised to MM/DD/YYYY
 *   - native Date instance
 *   - empty / null / undefined → ""
 */
export function fmtDate(value) {
  if (!value) return "";
  if (value instanceof Date && !Number.isNaN(value.valueOf())) {
    return `${pad2(value.getMonth() + 1)}/${pad2(value.getDate())}/${value.getFullYear()}`;
  }
  if (typeof value !== "string") return "";
  const head = value.slice(0, 10); // YYYY-MM-DD
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(head);
  if (m) return `${m[2]}/${m[3]}/${m[1]}`;
  // Already MM-DD-YY or MM/DD/YYYY — normalise to slashes + 4-digit year.
  const m2 = /^(\d{2})[/\-](\d{2})[/\-](\d{2,4})$/.exec(value);
  if (m2) return `${m2[1]}/${m2[2]}/${pad4Year(m2[3])}`;
  return value;
}

/** MM/DD/YYYY HH:MM (24h). For audit-style timestamps. */
export function fmtDateTime(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.valueOf())) return typeof value === "string" ? value : "";
  return `${fmtDate(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
